import React from 'react';
import { Flex, Box, Text, Tooltip, TooltipContent, Icon } from '@customerio/pluma-components/react';
import { format } from 'date-fns';

interface ReleaseVersionData {
  version: string;
  createdAt: string | Date;
}

interface AppFooterProps {
  release?: ReleaseVersionData;
}

export const AppFooter: React.FC<AppFooterProps> = ({ release }) => {
  const formatReleaseDate = (date: string | Date) => {
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    return format(dateObj, 'MMM d, yyyy h:mm a');
  };

  return (
    <Flex as="footer" px="200" mt="250" alignItems="center" justifyContent="space-between" data-test-app-footer>
      <Box>
        {release != null ? (
          <Tooltip>
            <Text data-test-app-footer-release size="xxs" color="subtle">
              Version {release.version}
            </Text>
            <TooltipContent>Released {formatReleaseDate(release.createdAt)}</TooltipContent>
          </Tooltip>
        ) : null}
      </Box>
      <Box>
        <Flex as="p" alignItems="center" gap="050" style={{ userSelect: 'none', whiteSpace: 'nowrap' }}>
          <Box as="span">Made with</Box>
          <Icon name="heart" size="md" aria-label="love" />
          <Box as="span">around the world.</Box>
        </Flex>
      </Box>
    </Flex>
  );
};
